import { render, staticRenderFns } from "./OrderDelivered.vue?vue&type=template&id=87984bbe&scoped=true&"
import script from "./OrderDelivered.vue?vue&type=script&lang=js&"
export * from "./OrderDelivered.vue?vue&type=script&lang=js&"
import style0 from "./OrderDelivered.vue?vue&type=style&index=0&id=87984bbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87984bbe",
  null
  
)

export default component.exports